import React, { memo } from 'react'
import { urlCommonAssets } from '../../Constants';

const Loading = () => {

    return (
        <article className="vh-100 d-flex justify-content-center align-items-center loading-container">
            <img className="img-fluid" src={`${urlCommonAssets}/img/loading-brand.gif`} alt="Cargando" />
        </article>
    )
}

export default memo(Loading);

